exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header__dropdown-menu{min-width:auto!important;border-color:#ddd;border-radius:4px!important}.header__dropdown-toggle{background-color:transparent;padding:0 15px;cursor:pointer}.header__dropdown-menu a{cursor:pointer}.header__dropdown-icon{margin-left:5px;transition:all .3s ease-in-out}.header__dropdown-icon--active{transform:rotateZ(540deg)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/components/Header/components/HeaderDropDown/style.css
 ** module id = 1981
 ** module chunks = 73
 **/